
import { CommonModule } from '@angular/common';
import { Component, computed, inject, Input, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { InputGroupModule } from 'primeng/inputgroup';
import { InputTextModule } from 'primeng/inputtext';
import { DrawerModule } from 'primeng/drawer';
import { BinderDialogService } from '@/services/app/binder-dialog.service';

@Component({
    selector: 'app-dynamic-drawer',
    imports: [CommonModule, DrawerModule],
    template: `
    <p-drawer [header]="dialog.drawerHeader()" [visible]="visible()" [blockScroll]="true" (onHide)="onClose()" position="full" [blockScroll]="true">
    <ng-container *ngIf="component() as comp">
          <ng-container *ngComponentOutlet="comp" class="h-full block"></ng-container>
      </ng-container>
</p-drawer>
    `,
    styles: [`
      /* Make the fullscreen drawer layout column + fill the viewport */
.assemblies-drawer .p-drawer-content {
  display: flex;
  flex-direction: column;
  height: 100vh;         /* fill screen */
  overflow: hidden;      /* <- prevent outer scroll */
  padding: 0;            /* we’ll pad inside child */
}

/* Header is fixed-height, body takes the rest */
.assemblies-drawer .p-drawer-header {
  flex: 0 0 auto;
}

/* Drawer body becomes a flex container we control */
.assemblies-drawer .p-drawer-body {
  flex: 1 1 auto;
  min-height: 0;         /* critical for inner scrolling */
  overflow: hidden;      /* no scroll here, only inside your panes */
  padding: 0;            /* your component handles spacing */
}

    `],
    
  })
export class DynamicDrawerComponent {
  dialog = inject(BinderDialogService);
  component = this.dialog.drawerComponent;
  visible = computed(() => !!this.component());

  onClose() {
    this.dialog.closeDrawer();
  }
}